import { Container } from '@pixi/react'
import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { gameConfig } from '../config'
import { winningManager } from '../domain/winning/WinningManager'

export const WinningPanel = () => {
  const winningFrameRef = useRef<PixiContainer>()

  useEffect(() => {
    winningManager.winningPanel = winningFrameRef.current as PixiContainer
  }, [])

  return (
    <Container
      name="winningPanel"
      visible={false}
      ref={(el: PixiContainer | null) => {
        winningFrameRef.current = el as PixiContainer
      }}
      x={gameConfig.resolution.width / 2}
      y={gameConfig.resolution.height / 2}
      eventMode="static"
      cursor="pointer"
    >
    </Container>
  )
}
